export default __webpack_public_path__ + "static/media/foto-maudy.1dc09e26.svg";